import React, { Fragment, useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import MetalOrderContext from "../../context/metalOrder/metalOrderContext";
import { Table, Tabs, message, Modal } from "antd";
import Select from "react-select";
import AuthContext from "../../context/auth/authContext";
import axios from "axios";

const MyOrders = () => {
    const navigate = useNavigate();
    const metalOrderContext = useContext(MetalOrderContext);
    const { deleteMetalOrder, setCurrentMetalOrder, updateMetalOrder, clearCurrentMetalOrder, loadingMetalOrder } = metalOrderContext;
    const authContext = useContext(AuthContext);
    const { user } = authContext;

    const [metalOrders, setMetalOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchMetalOrders();
    }, []);

    const fetchMetalOrders = async () => {
        try {
            setLoading(true);
            const response = await axios.get('/api/metalorder');
            setMetalOrders(response.data);
        } catch (err) {
            console.error('Error fetching metal orders:', err);
            message.error('Failed to fetch metal orders');
        } finally {
            setLoading(false);
        }
    };

    const handleRemoveMetalOrder = (metalOrder) => {
        Modal.confirm({
            title: "Are you sure you want to delete this Metal Order?",
            okText: "Yes",
            okType: "danger",
            onOk: async () => {
                try {
                    await axios.delete(`/api/metalorder/delete/${metalOrder._id}`);
                    message.success('Order deleted successfully');
                    fetchMetalOrders();
                } catch (err) {
                    console.error('Error deleting order:', err);
                    message.error('Failed to delete order');
                }
            },
        });
    };

    const handleViewMetalOrder = (metalOrder) => {
        setCurrentMetalOrder(metalOrder);
        navigate(`/shop/purchase/metal/form`);
    };

    const statusOptions = [
        { value: "Pending", label: "Pending" },
        { value: "Confirmed", label: "Confirmed" },
        { value: "Recieved", label: "Recieved" },
    ];

    const handleStatusChange = async (record, e) => {
        try {
            const response = await axios.put(`/api/metalorder/update/${record._id}`, {
                status: e.value
            });
            message.success('Order status updated successfully');
            fetchMetalOrders();
        } catch (err) {
            console.error('Error updating order status:', err);
            message.error('Failed to update order status');
        }
    };

    const columns = [
        {
            title: "PO#",
            dataIndex: "purchaseOrderNumber",
        },
        ...(user.firstChoiceCustomer
            ? [
                {
                    title: "Order #",
                    dataIndex: "strOrderNumber",
                },
            ]
            : []),
        {
            title: "Created Date",
            dataIndex: "createdAt",
            render: (value) => {
                return <span>{new Date(value).toLocaleDateString()}</span>;
            },
        },
        {
            title: "Status",
            width: "15%",
            render: (text, record) => (
                <Select
                    className="basic-single"
                    menuPortalTarget={document.body}
                    menuPosition={"fixed"}
                    value={statusOptions.find((option) => option.value === record.status) || null}
                    name="status"
                    options={statusOptions}
                    onChange={(e) => handleStatusChange(record, e)}
                />
            ),
        },
        {
            title: "Actions",
            width: "10%",
            render: (text, record) => (
                <Fragment>
                    <button
                        className="btn btn-xs btn-outline-danger float-start"
                        type="button"
                        onClick={() => handleRemoveMetalOrder(record)}
                    >
                        Delete
                    </button>
                    <button
                        className="btn btn-xs btn-outline-primary float-end"
                        type="button"
                        onClick={() => handleViewMetalOrder(record)}
                    >
                        View
                    </button>
                </Fragment>
            ),
        },
    ];

    const items = [
        {
            key: 'all',
            label: 'All Orders',
            children: (
                <Table
                    rowClassName={() => "hover-row"}
                    loading={loading}
                    pagination={{
                        defaultPageSize: 10,
                        pageSize: undefined,
                        showSizeChanger: true,
                        pageSizeOptions: ['10', '20', '50', '100'],
                        // showQuickJumper: true
                    }}
                    columns={columns}
                    dataSource={metalOrders}
                    rowKey="_id"
                />
            ),
        },
        {
            key: 'pending',
            label: 'Pending',
            children: (
                <Table
                    rowClassName={() => "hover-row"}
                    loading={loading}
                    pagination={{ pageSize: 40 }}
                    columns={columns}
                    dataSource={metalOrders.filter(order => order.status === 'Pending')}
                    rowKey="_id"
                />
            ),
        },
        {
            key: 'confirmed',
            label: 'Confirmed',
            children: (
                <Table
                    rowClassName={() => "hover-row"}
                    loading={loading}
                    pagination={{ pageSize: 40 }}
                    columns={columns}
                    dataSource={metalOrders.filter(order => order.status === 'Confirmed')}
                    rowKey="_id"
                />
            ),
        },
        {
            key: 'received',
            label: 'Received',
            children: (
                <Table
                    rowClassName={() => "hover-row"}
                    loading={loading}
                    pagination={{ pageSize: 40 }}
                    columns={columns}
                    dataSource={metalOrders.filter(order => order.status === 'Recieved')}
                    rowKey="_id"
                />
            ),
        },
    ];

    return (
        <div style={{ padding: '24px' }}>
            <div className="row">
                <div className="col-md-12">
                    <button
                        className="btn btn-outline-danger float-end mb-4"
                        type="button"
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </button>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <Tabs defaultActiveKey="all" items={items} />
                </div>
            </div>
        </div>
    );
};

export default MyOrders; 